import styled from 'styled-components'

export const SellerBusinessPrefWrapper = styled.div`
    h6{
        font-family: "latobold";
        font-size: 22px;
    }
    .header-pTag-style{
        font-family: "latobold";
        margin: 20px 0;
    }
    .separator-line{
        width: 100%;
        border-top: 1px solid rgb(135, 205, 241);
        margin: 15px 0px 30px 0;
        display: flex;
    }
    .type-wrapper, .size-wrapper, .specialServices-wrapper{
        p{
            font-family: 'latobold';
            margin: 20px 0px;
        }
    }
    .type-checkbox-style, .size-checkbox-style, .specialServices-checkbox-style{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 10px;
        .checkbox-field{
            margin: 0px;
            width: 200px;
        }
    }
    .radio-check-disable-class{
        .radio-checkmark{
            border: 1px solid #979797;
        }
        .radio-checkmark:after {
            background: #979797;
        }
    }
    @media (max-width: 767px){
        .condition-checkbox-style, .type-checkbox-style, .size-checkbox-style, .specialServices-checkbox-style{
            grid-template-columns: 1fr 1fr;
        }
    }
`;